import React from 'react';
import { Sparkles } from 'lucide-react';

interface SparkleEffectProps {
  isShiny?: boolean;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  intensity?: 'low' | 'medium' | 'high';
}

const SparkleEffect: React.FC<SparkleEffectProps> = ({
  isShiny = false,
  className = '',
  size = 'medium',
  intensity = 'medium'
}) => {
  if (!isShiny) return null;

  const sizeMap = {
    small: 'w-3 h-3',
    medium: 'w-4 h-4',
    large: 'w-6 h-6'
  };

  const particleCount = {
    low: 3,
    medium: 5,
    high: 8
  };

  const sparkleSize = sizeMap[size];
  const count = particleCount[intensity];

  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      {/* Particules scintillantes */}
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="absolute animate-ping"
          style={{
            left: `${10 + (i * 20) % 80}%`,
            top: `${10 + (i * 15) % 80}%`,
            animationDelay: `${i * 300}ms`,
            animationDuration: `${2000 + i * 200}ms`
          }}
        >
          <Sparkles 
            className={`text-yellow-400 ${sparkleSize}`}
            style={{
              filter: 'drop-shadow(0 0 2px rgba(251, 191, 36, 0.8))'
            }}
          />
        </div>
      ))}
      
      {/* Effet d'étoiles plus petites */}
      {Array.from({ length: Math.floor(count / 2) }).map((_, i) => (
        <div
          key={`star-${i}`}
          className="absolute animate-pulse"
          style={{
            left: `${20 + (i * 30) % 60}%`,
            top: `${20 + (i * 25) % 60}%`,
            animationDelay: `${i * 400 + 1000}ms`,
            animationDuration: `${1500 + i * 300}ms`
          }}
        >
          <div className="w-1 h-1 bg-yellow-400 rounded-full" 
               style={{
                 filter: 'drop-shadow(0 0 1px rgba(251, 191, 36, 1))'
               }} />
        </div>
      ))}
      
      {/* Étoiles supplémentaires autour de l'objet */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={`outer-star-${i}`}
          className="absolute animate-ping"
          style={{
            left: `${-5 + (i * 110) % 110}%`,
            top: `${-5 + (i * 70) % 110}%`,
            animationDelay: `${i * 600 + 500}ms`,
            animationDuration: `${2500 + i * 100}ms`
          }}
        >
          <div className="w-2 h-2 bg-yellow-300 rounded-full" 
               style={{
                 clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)',
                 filter: 'drop-shadow(0 0 2px rgba(251, 191, 36, 0.9))'
               }} />
        </div>
      ))}
    </div>
  );
};

export default SparkleEffect;